module.exports = __webpack_public_path__ + "static/media/super_pack_fr_chat_automne.4fefe53c.png";